import {json,postBiz} from '../core/coreapi';
import {
  BudgetValidationTransitionPayload,
  BudgetValidationWorkbenchModel,
} from './budgetvalidation.models';
import {normalizeBudgetValidationWorkbench} from './budgetvalidation.normalizers';

export const fetchBudgetValidationWorkbench=async(
  planningcycleid:number,
):Promise<BudgetValidationWorkbenchModel>=>{
  const response=await postBiz({
    s:'budgetvalidation',
    a:'workbench',
    pci:planningcycleid,
  });
  return normalizeBudgetValidationWorkbench(json(response));
};

export const transitionBudgetValidation=async(
  payload:BudgetValidationTransitionPayload,
)=>json(
  await postBiz({
    s:'budgetvalidation',
    a:'transition',
    vid:payload.validationid,
    act:payload.actioncode,
    tgt:payload.targetphasecode??null,
    rsn:payload.reason,
    rmk:payload.remarks??'',
    stp:payload.stamp??null,
  }),
);
